import { Pipe, PipeTransform } from '@angular/core';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safePipe'
})
export class SafePipePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(url: string, prefix = '', suffix = ''): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(prefix + url + suffix);
  }

}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/pipes/safe-pipe.pipe.ts